import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useHeader } from '@/hooks/useHeader'
import ChildPageHeader from '@/components/UI/ChildPageHeader'
import ArchiveKnowledgeDatatableView from '@/components/UI/KnowledgeDatatableComponent/ArchiveKnowledgeDatatableView'

const ArchivedKnowledge = () => {
  const { t } = useTranslation('translation')
  const { setHeaderText } = useHeader()

  useEffect(() => {
    setHeaderText('Knowledge')
  }, [setHeaderText])

  return (
    <section className="page-mid-wraper h-without-foter">
      <ChildPageHeader
        title={t('Archived Knowledge')}
        subTitle={t(
          'View and manage archived flash cards and documents. You can restore or permanently delete items from here.',
        )}
      />
      <ArchiveKnowledgeDatatableView />
    </section>
  )
}

export default ArchivedKnowledge
